import {
    ADD_REAL_ESTATE_PRODUCT_DATA_REQUEST,
    ADD_REAL_ESTATE_PRODUCT_DATA_SUCCESS,
    ADD_REAL_ESTATE_PRODUCT_DATA_FAILED,
    REAL_ESTATE_CLEAR_ADD_PRODUCT
} from '../../actions/product/add-real-estate-product-data'

const initialState = {
    product: null,
    error: null,
    requesting: false,
    completed: false,
}

export const realEstateNewProduct = (state = initialState, action) => {
    switch (action.type) {
        case ADD_REAL_ESTATE_PRODUCT_DATA_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                error: null,
            })
        case ADD_REAL_ESTATE_PRODUCT_DATA_SUCCESS:
            return Object.assign({}, state, {
                product: action.payload.data.payload,
                requesting: false,
                error: null,
                completed: true
            })
        case ADD_REAL_ESTATE_PRODUCT_DATA_FAILED:
            return Object.assign({}, state, {
                requesting: false,
                error: action.error
            })
        case REAL_ESTATE_CLEAR_ADD_PRODUCT:
            return initialState
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/product/real-estate-new-product.js